// Pointer / touch parallax for the landing vinyl record. Maps cursor position
// over the stage to a small 3D tilt via the --px/--py custom properties on
// `.vinyl`. These compose additively with the CSS hover-lean (--lean-x/-y), so
// the parallax never fights the directional lean. A tap still navigates — we
// never call preventDefault. Disabled entirely under prefers-reduced-motion.

const reduce = matchMedia("(prefers-reduced-motion: reduce)");
const stage = document.querySelector<HTMLElement>(".vinyl-stage");
const vinyl = stage?.querySelector<HTMLElement>(".vinyl");

if (stage && vinyl && !reduce.matches) {
  const MAX_X = 7; // deg, rotateY (left/right)
  const MAX_Y = 5; // deg, rotateX (up/down)
  let raf = 0;
  let tx = 0;
  let ty = 0;

  const apply = () => {
    raf = 0;
    vinyl.style.setProperty("--px", `${tx.toFixed(2)}deg`);
    vinyl.style.setProperty("--py", `${ty.toFixed(2)}deg`);
  };
  const schedule = () => {
    if (!raf) raf = requestAnimationFrame(apply);
  };

  const onMove = (e: PointerEvent) => {
    const r = stage.getBoundingClientRect();
    const nx = (e.clientX - r.left) / r.width - 0.5; // -0.5 … 0.5
    const ny = (e.clientY - r.top) / r.height - 0.5;
    tx = nx * 2 * MAX_X; // pointer right → tilt right
    ty = ny * 2 * MAX_Y; // pointer down → top leans back
    schedule();
  };
  const reset = () => {
    tx = 0;
    ty = 0;
    schedule();
  };

  stage.addEventListener("pointermove", onMove);
  stage.addEventListener("pointerleave", reset);
  stage.addEventListener("pointerup", reset);
  stage.addEventListener("pointercancel", reset);
}
